module.exports = __webpack_public_path__ + "img/u164.52af39f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/figma/u164.png
// module id = 527v
// module chunks = 0